import React from 'react';
import { CodeSnippet, Link } from 'carbon-components-react';
import { getFeatureServerUrl } from 'services/map.service';

const GISFeatureLayers: React.FC = () => {
  const featureLayerUrl = `${getFeatureServerUrl('Enquiries', true)}/0`;
  return (
    <div id="gisFeatureLayers" className="gis-feature-layers spacing-padding">
      <div className="sub-section-title">GIS feature layers</div>
      <div className="section-description">
        Add available enquiry features as a layer to your GIS application
      </div>
      <div className="codesnippet-container">
        <div className="label-link-container">
          <div>Enquiries</div>
          <div>
            <Link
              href={`https://www.arcgis.com/home/webmap/viewer.html?url=${encodeURIComponent(
                featureLayerUrl
              )}`}
              target="_blank"
            >
              View in ArcGIS Online
            </Link>
          </div>
        </div>
        <CodeSnippet type="multi" wrapText={true}>
          {featureLayerUrl}
        </CodeSnippet>
      </div>
      <div id="sharingEnquiriesAnchor"></div>
    </div>
  );
};

export default React.memo(GISFeatureLayers);
